var host = location.host == '' ? '' : location.protocol+'//'+location.host;
var path_res = location.host == '' ? './' : host+process.env.PATH_RES;

const config = {
  API_URL: (location.hostname == 'localhost')? 'http://rongmeiti.dev58.myzaker.com' : location.protocol+'//'+location.host,
  APP_UA: 'ZKRMT', //UA识别 ZKRMT/1.0 ； 以前的com.dio.rmt  
  APP_KEY: 'Tgj8FxWIT4RWhhcq',
  APP_AKEY: 'Bearer',
  HOST: host, //http://xx.xxx.com
  HOST_RES: path_res //http://xx.xxx.com/xxx/
}
module.exports = config



//////////////////
// WEBPACK FOOTER
// ./pc/common/config/index.js
// module id = 25
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13